<template>
    服务正在维护中,请稍后重试
</template>

<script>
import {defineComponent} from 'vue';

export default defineComponent({
    name: 'Error',
});
</script>

<style scoped>

</style>
